import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import {
	isRecord,
	isSubmittedLookup,
	type LookupInput,
	type SubmittedLookup,
} from "../utilities/signup-lookup.ts";
import { journeyStorage, journeyStorageKey } from "../utilities/session-storage.ts";

type LookupStore = {
	lookup: SubmittedLookup | null;
	hasHydrated: boolean;
	submitLookup: (input: LookupInput) => void;
	clearLookup: () => void;
};

export const useLookupStore = create<LookupStore>()(
	persist(
		(set, get) => ({
			lookup: null,
			hasHydrated: false,
			submitLookup: input =>
				set({ lookup: { ...input, revision: (get().lookup?.revision ?? 0) + 1 } }),
			clearLookup: () => set({ lookup: null }),
		}),
		{
			name: journeyStorageKey("solstice-lookup-store"),
			storage: createJSONStorage(() => journeyStorage),
			skipHydration: true,
			partialize: state => ({ lookup: state.lookup }),
			merge: (persisted, current) => ({
				...current,
				lookup:
					isRecord(persisted) && isSubmittedLookup(persisted.lookup) ? persisted.lookup : null,
			}),
		},
	),
);
